import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, X as CloseIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="flex justify-between items-center h-20" data-id="element-217">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-218">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vJ4LnEANA2qYvkkH1pNfQy/design-d5307099-5cbb-4264-b386-3c96f879a243.png" alt="Farasha Medical Aid Logo" className="h-12 w-auto" data-id="element-219" />
            <span className="ml-3 text-primary-deep-blue font-playfair font-semibold" data-id="element-220">
              Farasha Medical Aid
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-6" data-id="element-221">
            <Link to="/" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-222">
              Home
            </Link>
            <Link to="/about" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-223">
              About
            </Link>
            <Link to="/coptic-people" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-224">
              The Coptic People
            </Link>
            <Link to="/blog" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-225">
              Blog
            </Link>
            <Link to="/contact" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-226">
              Contact
            </Link>
          </nav>

          {/* Action Button */}
          <div className="hidden lg:flex items-center" data-id="element-227">
            <Link to="/donate" className="bg-primary-royal-blue hover:bg-primary-deep-blue text-white px-6 py-2 rounded-md font-inter transition-colors font-medium" data-id="element-228">
              Donate
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-229">
            <button onClick={toggleMenu} className="inline-flex items-center justify-center p-2 rounded-md text-primary-deep-blue hover:bg-neutral-offwhite focus:outline-none" data-id="element-230">
              {isMenuOpen ? <CloseIcon size={24} data-id="element-231" /> : <MenuIcon size={24} data-id="element-232" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="lg:hidden" data-id="element-233">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white" data-id="element-234">
            <Link to="/" className="block px-3 py-2 text-primary-deep-blue font-inter" onClick={() => setIsMenuOpen(false)} data-id="element-235">
              Home
            </Link>
            <Link to="/about" className="block px-3 py-2 text-primary-deep-blue font-inter" onClick={() => setIsMenuOpen(false)} data-id="element-236">
              About
            </Link>
            <Link to="/coptic-people" className="block px-3 py-2 text-primary-deep-blue font-inter" onClick={() => setIsMenuOpen(false)} data-id="element-237">
              The Coptic People
            </Link>
            <Link to="/blog" className="block px-3 py-2 text-primary-deep-blue font-inter" onClick={() => setIsMenuOpen(false)} data-id="element-238">
              Blog
            </Link>
            <Link to="/contact" className="block px-3 py-2 text-primary-deep-blue font-inter" onClick={() => setIsMenuOpen(false)} data-id="element-239">
              Contact
            </Link>
            <Link to="/donate" className="block px-3 py-2 bg-primary-royal-blue text-white rounded-md font-inter font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-240">
              Donate
            </Link>
          </div>
        </div>}
    </header>;
}